import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const UpdateAllowedOriginsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAllowedOrigins"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keyApplication"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origins"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"applicationKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyApplication"}}},{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowedOrigins"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origins"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowedOrigins"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"UpdateAllowedOrigins","document":UpdateAllowedOriginsDocument}} as const;
export type UpdateAllowedOriginsMutationVariables = Types.Exact<{
  keyApplication: Types.Scalars['String']['input'];
  origins?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type UpdateAllowedOriginsMutation = (
  { __typename: 'Mutation' }
  & { updateApplication?: Types.Maybe<(
    { __typename: 'Application' }
    & Pick<Types.Application, 'id' | 'allowedOrigins' | 'key'>
  )> }
);

export type UpdateAllowedOriginsMutationFn = Apollo.MutationFunction<
  UpdateAllowedOriginsMutation,
  UpdateAllowedOriginsMutationVariables
>;

/**
 * __useUpdateAllowedOriginsMutation__
 *
 * To run a mutation, you first call `useUpdateAllowedOriginsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowedOriginsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowedOriginsMutation, { data, loading, error }] = useUpdateAllowedOriginsMutation({
 *   variables: {
 *      keyApplication: // value for 'keyApplication'
 *      origins: // value for 'origins'
 *   },
 * });
 */
export function useUpdateAllowedOriginsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAllowedOriginsMutation,
    UpdateAllowedOriginsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAllowedOriginsMutation,
    UpdateAllowedOriginsMutationVariables
  >(UpdateAllowedOriginsDocument, options);
}
export type UpdateAllowedOriginsMutationHookResult = ReturnType<
  typeof useUpdateAllowedOriginsMutation
>;
export type UpdateAllowedOriginsMutationResult =
  Apollo.MutationResult<UpdateAllowedOriginsMutation>;
export type UpdateAllowedOriginsMutationOptions = Apollo.BaseMutationOptions<
  UpdateAllowedOriginsMutation,
  UpdateAllowedOriginsMutationVariables
>;
